'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddCatalogItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _sharedProgressBar = require('@bibliocommons/shared-progress-bar');

var _sharedProgressBar2 = _interopRequireDefault(_sharedProgressBar);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _searchResults = require('../../search-results');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _searchBar = require('../../search-bar');

var _searchBar2 = _interopRequireDefault(_searchBar);

var _searchResultItem = require('../../search-result-item');

var _searchResultItem2 = _interopRequireDefault(_searchResultItem);

var _searchResultAddButton = require('../../search-result-add-button');

var _searchResultAddButton2 = _interopRequireDefault(_searchResultAddButton);

require('../styles/AddCatalogItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddCatalogItem = exports.AddCatalogItem = function (_BcReactComponent) {
  _inherits(AddCatalogItem, _BcReactComponent);

  function AddCatalogItem(props) {
    _classCallCheck(this, AddCatalogItem);

    var _this = _possibleConstructorReturn(this, (AddCatalogItem.__proto__ || Object.getPrototypeOf(AddCatalogItem)).call(this, props));

    _this.bindAll('addItem', 'handleQueryChange');
    _this._searchResultItems = {};
    return _this;
  }

  _createClass(AddCatalogItem, [{
    key: 'addItem',
    value: function addItem(item) {
      this.props.handleAddBib(item);
    }
  }, {
    key: 'handleQueryChange',
    value: function handleQueryChange(value) {
      this.props.handleSearchParameterChange(_immutable2.default.Map({ query: value }));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var doneSearching = prevProps.searchParams.get('searching') && !this.props.searchParams.get('searching');
      if (doneSearching) {
        // If a search just finished, set focus to the first result
        if (this._searchResultItems && this._searchResultItems[0]) {
          this._searchResultItems[0].focusOnTitle();
        }
      } else if (this.props.searchResults.size > prevProps.searchResults.size) {
        // If new results were added, set focus on title of next search result added
        var newSearchResultIndex = prevProps.searchResults.size;
        if (this._searchResultItems && this._searchResultItems[newSearchResultIndex]) {
          this._searchResultItems[newSearchResultIndex].focusOnTitle();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          searchParams = _props.searchParams,
          handleSearch = _props.handleSearch,
          searchResults = _props.searchResults,
          getNextPageSearchResults = _props.getNextPageSearchResults,
          pageSize = _props.pageSize,
          listItems = _props.listItems,
          handleAddBib = _props.handleAddBib,
          keepSearchResultsOpen = _props.keepSearchResultsOpen;


      return (
        // A non-empty form action is required for having a search button appear on iOS 8+
        // See http://stackoverflow.com/questions/4864167/show-search-button-in-iphone-ipad-safari-keyboard
        _react2.default.createElement(
          'form',
          { className: 'cp-add-catalog-item', action: '.' },
          _react2.default.createElement(_searchBar2.default, {
            ref: function ref(el) {
              _this2._searchBar = el;
            },
            query: searchParams.get('query'),
            searching: searchParams.get('searching'),
            handleChange: this.handleQueryChange,
            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_search_for_catalog_item' }),
            handleSearch: handleSearch }),
          _react2.default.createElement(
            'div',
            { className: 'progress-bar-wrapper' },
            _react2.default.createElement(_sharedProgressBar2.default, { active: searchParams.get('searching') })
          ),
          _react2.default.createElement(
            _searchResults2.default,
            {
              searchParams: searchParams,
              searchResults: searchResults,
              pageSize: pageSize,
              listItems: listItems,
              displayShowMore: true,
              displayDoneButton: keepSearchResultsOpen && searchResults.size > 0,
              handleDoneButtonClicked: this.props.handleCloseAddToList,
              getNextPageSearchResults: getNextPageSearchResults },
            searchResults.slice(0, searchParams.get('page') * pageSize).map(function (item, i) {
              return _react2.default.createElement(
                _searchResultItem2.default,
                {
                  key: i,
                  item: item,
                  listItems: listItems,
                  availabilityDetailActions: _this2.props.availabilityDetailActions,
                  ref: function ref(el) {
                    return _this2._searchResultItems[i] = el;
                  } },
                _react2.default.createElement(_searchResultAddButton2.default, {
                  item: item,
                  listItems: listItems,
                  handleAddBib: handleAddBib })
              );
            })
          )
        )
      );
    }
  }]);

  return AddCatalogItem;
}(_baseBcReactComponent2.default);

AddCatalogItem.propTypes = {
  listID: _react.PropTypes.number,
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map,
  keepSearchResultsOpen: _react.PropTypes.bool,
  handleSearch: _react.PropTypes.func.isRequired,
  handleAddBib: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  pageSize: _react.PropTypes.number,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,
  handleClearSearch: _react.PropTypes.func.isRequired,
  handleCloseAddToList: _react.PropTypes.func.isRequired,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,

  // injected by manageFocus
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
};

AddCatalogItem.defaultProps = {
  pageSize: 5
};

exports.default = (0, _baseAccessibilityManageFocus2.default)(AddCatalogItem);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-catalog-item/components/AddCatalogItem.component.js
// module id = 1269
// module chunks = 0